import { render, staticRenderFns } from "./DesenfumageAdmin.vue?vue&type=template&id=2916f7b4&scoped=true&"
import script from "./DesenfumageAdmin.vue?vue&type=script&lang=js&"
export * from "./DesenfumageAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916f7b4",
  null
  
)

export default component.exports